import React, { useCallback } from "react";
import "./app-radio.component.scoped.scss";
import {
  Radio,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { AppRadioComponentProps } from "./app-radio.component.types";

const AppRadioComponent: React.FC<AppRadioComponentProps> = ({
  value,
  name,
  options,
  disabled = false,
  direction = "column",
  onChange,
  ...radioGroupProps
}: AppRadioComponentProps) => {
  const handleChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, selectedValue: string) => {
      onChange(selectedValue);
    },
    [onChange],
  );

  return (
    <FormControl component="fieldset">
      <RadioGroup
        name={name}
        value={value}
        onChange={handleChange}
        style={{
          flexDirection: direction,
          ...radioGroupProps.style,
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={disabled || option.disabled}
            className="mb-0 app-radio-component"
            control={<Radio color="primary" />}
            label={
              typeof option.label === "string" ? (
                <Typography variant="body1" color="textPrimary">
                  {option.label}
                </Typography>
              ) : (
                option.label
              )
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default AppRadioComponent;
